/**
 * Comprobantes electrónicos del SRI (esquema offline). Verificado sept. 2026:
 * clave de acceso de 49 dígitos con módulo 11; IVA 0 % código "0", 15 % código "4";
 * consumidor final hasta USD 50 (general / RIMPE emprendedor) o USD 200 (RIMPE negocio popular).
 * La firma XAdES-BES y el envío a los servicios web se implementan en la fase 2.
 */

export type Regimen = "general" | "emprendedor" | "popular";
export const LIMITE_CONSUMIDOR_FINAL: Readonly<Record<Regimen, number>> = { general: 50, emprendedor: 50, popular: 200 };
export const CODIGO_IVA: Readonly<Record<number, string>> = { 0: "0", 5: "5", 15: "4" };
export const FORMA_PAGO: Readonly<Record<string, string>> = {
  efectivo: "01", tarjeta_debito: "16", tarjeta_credito: "19", transferencia: "20", otros_financiero: "20",
};
export const TIPO_ID_COMPRADOR = { ruc: "04", cedula: "05", pasaporte: "06", consumidor_final: "07" } as const;

/** Dígito verificador módulo 11 sobre los 48 primeros dígitos (pesos 2..7 desde la derecha; 11→0, 10→1). */
export function modulo11(d48: string): number {
  let s = 0, w = 2;
  for (let i = d48.length - 1; i >= 0; i--) {
    s += Number(d48[i]) * w;
    w = w === 7 ? 2 : w + 1;
  }
  const r = 11 - (s % 11);
  return r === 11 ? 0 : r === 10 ? 1 : r;
}

export interface DatosClave {
  fecha: string; // yyyy-mm-dd
  tipoComprobante?: string; // 01 factura, 04 nota de crédito
  ruc: string;
  ambiente: "1" | "2";
  establecimiento: string; // 3 dígitos
  puntoEmision: string; // 3 dígitos
  secuencial: number;
  codigoNumerico: string; // 8 dígitos
  tipoEmision?: "1";
}

export function claveAcceso(d: DatosClave): string {
  const [y, m, dd] = d.fecha.split("-");
  const base = dd + m + y + (d.tipoComprobante ?? "01") + d.ruc + d.ambiente + d.establecimiento.padStart(3, "0") +
    d.puntoEmision.padStart(3, "0") + String(d.secuencial).padStart(9, "0") + d.codigoNumerico.padStart(8, "0") + (d.tipoEmision ?? "1");
  if (!/^\d{48}$/.test(base)) throw new Error("Datos inválidos para la clave de acceso");
  return base + modulo11(base);
}

export function claveValida(clave: string): boolean {
  return /^\d{49}$/.test(clave) && modulo11(clave.slice(0, 48)) === Number(clave[48]);
}

export function puedeConsumidorFinal(total: number, regimen: Regimen): boolean {
  return total < LIMITE_CONSUMIDOR_FINAL[regimen];
}
